import { Add, Remove } from "@mui/icons-material";
import { IconButton, Slider, Stack } from "@mui/material";
import { PayloadAction } from "@reduxjs/toolkit";

export interface ScaleSliderProps {
  scale: number;
  scales: number[];
  setScale: (number) => void;
}

const ScaleSlider: React.FC<ScaleSliderProps> = (props: ScaleSliderProps) => {
  const { scale, setScale, scales } = props;

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{ p: 0.25, gap: 1, backgroundColor: "backgroundAlpha.main", borderRadius: "6px" }}
    >
      <IconButton
        sx={{ borderRadius: "4px", width: "28px", height: "28px" }}
        size="small"
        onClick={(e) => {
          if (scales.findIndex((x) => x === scale) > 0) setScale(scales[scales.findIndex((x) => x === scale) - 1]);
        }}
      >
        <Remove fontSize={"small"} />
      </IconButton>
      <Slider
        sx={{ width: 60, flexGrow: 1 }}
        size="small"
        step={1}
        marks={scales.map((x, i) => ({ value: i }))}
        max={scales.length - 1}
        min={0}
        value={scales.findIndex((x) => x === scale)}
        aria-label="Default"
        onChange={(e, value) => setScale(scales[value as number])}
      />
      <IconButton
        sx={{ borderRadius: "4px", width: "28px", height: "28px" }}
        size="small"
        onClick={(e) => {
          if (scales.findIndex((x) => x === scale) < scales.length - 1)
            setScale(scales[scales.findIndex((x) => x === scale) + 1]);
        }}
      >
        <Add fontSize={"small"} />
      </IconButton>
    </Stack>
  );
};

export default ScaleSlider;
